import { render, staticRenderFns } from "./TRCRenewal.vue?vue&type=template&id=779707f2&"
import script from "./TRCRenewal.vue?vue&type=script&lang=ts&"
export * from "./TRCRenewal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports